import React, { Component } from 'react';
import { connect } from 'react-redux';
import TableC from '../../basicElement/TableC';
import API_URL from '../../../common/url';
import $ from '../../../common/AjaxRequest';
import { actions } from '../../../actions/researchCenter/detail';

// 关联类型
export const RelateType = {
    ACCURACY: '准确关联',
    TEMPORARY: '临时关联',
};

class WaitRelate extends Component {
    state = {
        data: [],
        loading: false,
        pagination: {
            current: 1,
            pageSize: 5,
        },
        sortParams: {},
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = () => {
        const { pagination, sortParams } = this.state;
        const { current, pageSize } = pagination;

        this.setState({ loading: true });
        const options = {
            url: API_URL.home.querySiteWithNoContract,
            data: {
                offset: current,
                limit: pageSize,
                ...sortParams,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalCount } = res;
                pagination.total = totalCount;
                this.setState({
                    data: datas,
                    pagination,
                    loading: false,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    relate = (record) => {
        const { investigationId, investigationName, investigationSiteCode  } = record;
        this.props.saveSearchParams({ siteCode: investigationSiteCode });
        sessionStorage.setItem('invId', investigationId);
        sessionStorage.setItem('invName', investigationName);
        sessionStorage.setItem('siteId', '0');
        sessionStorage.setItem('investigationSiteName', '');
        sessionStorage.setItem('curRole', 'PM');
        location.href = '/#/site/detail';
    }

    getColumns = () => {
        const columns = [{
            title: '项目简称',
            dataIndex: 'investigationName',
            key: 'investigationName',
            sorter: true,
        }, {
            title: '中心',
            dataIndex: 'investigationSiteName',
            key: 'investigationSiteName',
            width: 120,
            render: (text, record) => {
                const { investigationSiteName, investigationSiteCode } = record;
                return investigationSiteName ? `${investigationSiteName}（${investigationSiteCode}）` : '';
            }
        }, {
            title: '关联合同',
            dataIndex: 'temporaryJdeCode',
            key: 'temporaryJdeCode',
            width: 90,
        }, {
            title: '关联类型',
            dataIndex: 'relatedType',
            key: 'relatedType',
            width: 90,
            sorter: true,
            render: text => RelateType[text],
        }, {
            title: '操作',
            dataIndex: 'operation',
            key: 'operation',
            width: 70,
            render: (text, record, index) => {
                return <a onClick={() => this.relate(record)}>合同关联</a>
            }
        }];
        return columns;
    }
    
    handleTableChange = (params) => {
        this.setState(params, () => {
            this.loadData();
        });
    }

    render() {
        const { data, loading, pagination, sortParams } = this.state;
        return (
            <div className="flexItem outer">
                <div className="modTitle">中心-合同待关联</div>
                <div style={{ marginTop: 10 }}>
                    <TableC
                        columns={this.getColumns()}
                        data={data}
                        loading={loading}
                        sortParams={sortParams}
                        pagination={pagination}
                        onChange={this.handleTableChange}
                        rowKey="investigationSiteId"
                        className="waitRelate"
                        scrollY={258}
                    />
                </div>
            </div>
        );
    }
}

export default connect(null, actions)(WaitRelate);


// WEBPACK FOOTER //
// ./src/components/homePage/afficheNews/WaitRelate.js